import React from 'react';
import './helpandsupport.scss';
import { Pathname } from '../../../../Router/Pathname';
import ArrowLeft from '../../../../Assets/icons/ArrowLeft';
import LocationIcon from '../../../../Assets/icons/LocationIcon';
import CallCalling from '../../../../Assets/icons/CallCalling';
import SmsIcon from '../../../../Assets/icons/SmsIcon';
import { useLocation, useNavigate } from 'react-router-dom';


const HelpandSupportView = () => {
    const navigate=useNavigate();
    const location = useLocation(); 
    const fromChatBot = location.state?.fromChatBot || false;
    console.log("fromChatBot", fromChatBot);

    return (
        <main className='HelpandSupportView'>
            <div className="HelpandSupportView--navigate">
                <span onClick={() => {
                    if (fromChatBot) {
                        navigate(Pathname.CHAT_BOT)
                    } else {
                        navigate(`${Pathname.PROFILE}`)
                    }
                }}>
                    <ArrowLeft />
                </span>
                <p>Help and Support</p>
            </div>
                <div className="HelpandSupportView--content">
                <p>You can contact us anytime, from anywhere</p>
                <div>
                    <LocationIcon/>
                    <p>Plot No 171, Rd No 13, Jubilee Hills,Hyderabad, Telangana - 500033.</p>
                </div>
                <div>
                    <CallCalling/>
                    <p>+91 7995015483</p>
                </div>
                <div>
                    <SmsIcon/>
                    <p>support@lioncharge.tech</p>
                </div>
            </div>
        </main>
    );
};

export default HelpandSupportView;
